import React from "react";

import { CircularAvatar } from "..";

type AppProps = {
  firstName: string;
  lastName: string | undefined;
  profilePic: string | undefined;
  updatedAt: string;
};
const UpdatedByAndUpdatedAt = ({
  firstName,
  lastName,
  profilePic,
  updatedAt,
}: AppProps) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "left",
        alignItems: "start",
        gap: "7px",
      }}
    >
      <div style={{ marginTop: "5px" }}>
        <CircularAvatar
          name={`${firstName ? firstName : ""} ${lastName ? lastName : ""}`}
          image={profilePic && profilePic}
        />
      </div>
      <div>
        <span>
          {firstName} {lastName}
        </span>
        <p style={{ color: "#8f8f8f", fontSize: "12px" }}>{updatedAt}</p>
      </div>
    </div>
  );
};

export default UpdatedByAndUpdatedAt;
